import {
  FETCH_METAL_TYPE_REQUEST,
  FETCH_METAL_TYPE_SUCCESS,
  FETCH_METAL_TYPE_FAILURE,
  ADD_METAL_TYPE_REQUEST,
  ADD_METAL_TYPE_SUCCESS,
  ADD_METAL_TYPE_FAILURE,
  UPDATE_METAL_TYPE_REQUEST,
  UPDATE_METAL_TYPE_SUCCESS,
  UPDATE_METAL_TYPE_FAILURE,
  DELETE_METAL_TYPE_REQUEST,
  DELETE_METAL_TYPE_SUCCESS,
  DELETE_METAL_TYPE_FAILURE,
  METAL_TYPE_FORM_ERROR,
  METAL_TYPE_FORM_SUCCESS,
  SET_METAL_TYPE_EDIT,
  CLEAR_METAL_TYPE_EDIT,
} from '../../../../types/masters/metalPurity/metaltype/metalTypeTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingMetalType: null,
};

const metalTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_METAL_TYPE_REQUEST:
    case ADD_METAL_TYPE_REQUEST:
    case UPDATE_METAL_TYPE_REQUEST:
    case DELETE_METAL_TYPE_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_METAL_TYPE_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_METAL_TYPE_SUCCESS:
    case UPDATE_METAL_TYPE_SUCCESS:
    case DELETE_METAL_TYPE_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_METAL_TYPE_FAILURE:
    case ADD_METAL_TYPE_FAILURE:
    case UPDATE_METAL_TYPE_FAILURE:
    case DELETE_METAL_TYPE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case METAL_TYPE_FORM_ERROR:
      return { ...state, loading: false, formError: action.payload };
    case METAL_TYPE_FORM_SUCCESS:
      return { ...state, loading: false, formSuccess: action.payload };
    case SET_METAL_TYPE_EDIT:
      return { ...state, editingMetalType: action.payload };
    case CLEAR_METAL_TYPE_EDIT:
      return { ...state, editingMetalType: null };
    default:
      return state;
  }
};

export default metalTypeReducer; 